export default __webpack_public_path__ + "static/media/1920 spice rack side.146efa17.png";